/**
 * Summary panel: <h3> + Edit always visible; <ul> only when step has selection.
 * Step 5: two uls (5a, 5b) — each visible only if that sub-step has selection.
 */
(function () {
  const SUMMARY_ROWS = [
    { stepId: 'step1', goTo: 1, type: 'variant' },
    { stepId: 'step2', goTo: 2, type: 'addon' },
    { stepId: 'step3', goTo: 3, type: 'addon' },
    { stepId: 'step4', goTo: 4, type: 'addon' },
    {
      type: 'addon-split',
      goTo: 5,
      subs: [
        { stepId: 'step5a', ulSelector: '.summary-ul-5a' },
        { stepId: 'step5b', ulSelector: '.summary-ul-5b' }
      ]
    },
    { stepId: 'step6', goTo: 6, type: 'addon-multi' },
    { stepId: 'step7', goTo: 7, type: 'addon' }
  ];

  function getAddonFromCheckbox(cb) {
    if (!cb || !cb.checked) return null;

    const box = cb.closest('.option-box');
    if (!box) return null;

    const label = box.querySelector('.cd-addon-option-label');
    const price = box.querySelector('.cd-addon-option-price');

    return {
      label: label ? label.textContent.trim() : cb.dataset.title || '',
      price: price ? price.textContent.trim() : ''
    };
  }

  function getVariantFromStep1() {
    const step1 = document.getElementById('step1');
    if (!step1) return null;

    const radio =
      step1.querySelector('.cd-custom-varient input[type="radio"]:checked') ||
      step1.querySelector('input[type="radio"]:checked');

    if (!radio) return null;

    const label =
      step1.querySelector(`label[for="${radio.id}"]`) ||
      radio.closest('label.cd-custom-varient');

    if (!label) return null;

    const titleEl = label.querySelector('.variant-swatch-label');
    const priceEl = label.querySelector('.varinet-price');

    return {
      label: titleEl
        ? titleEl.childNodes[0]
          ? titleEl.childNodes[0].textContent.trim()
          : titleEl.textContent.trim()
        : '',
      price: priceEl ? priceEl.textContent.trim() : ''
    };
  }

  function getSingleAddonStep(stepId) {
    const stepEl = document.getElementById(stepId);
    if (!stepEl) return null;

    const cb = stepEl.querySelector('.addon-checkbox:checked');
    return getAddonFromCheckbox(cb);
  }

  function getStep6Multi() {
    const stepEl = document.getElementById('step6');
    if (!stepEl) return null;

    const checked = stepEl.querySelectorAll('.addon-checkbox:checked');
    if (!checked.length) return null;

    const labels = [];
    const prices = [];

    checked.forEach(function (cb) {
      const item = getAddonFromCheckbox(cb);
      if (item) {
        labels.push(item.label);
        prices.push(item.price);
      }
    });

    return {
      label: labels.join(', '),
      price: prices.join(', ')
    };
  }

  function hasSelection(data) {
    return !!(data && data.label && data.label !== '—');
  }

  /** Show ul + fill data, or hide ul when nothing selected */
  function renderRow(ul, data) {
    if (!ul) return false;

    if (!hasSelection(data)) {
      ul.innerHTML = '';
      ul.style.display = 'none';
      ul.setAttribute('hidden', '');
      ul.classList.add('summary-ul--hidden');
      return false;
    }

    ul.style.display = '';
    ul.removeAttribute('hidden');
    ul.classList.remove('summary-ul--hidden');
    ul.innerHTML =
      '<li class="summary-title">' +
      data.label +
      '</li><li class="summary-price">' +
      (data.price || '') +
      '</li>';

    return true;
  }

  function renderStep5Split(div, cfg) {
    if (!div || !cfg.subs) return;

    cfg.subs.forEach(function (sub) {
      const ul = div.querySelector(sub.ulSelector);
      const data = getSingleAddonStep(sub.stepId);
      renderRow(ul, data);
    });
  }

  function updateReviewData() {
    const container = document.querySelector('.edit-popup-btn-holder');
    if (!container) return;

    const reviewDivs = container.querySelectorAll('.crer-itnem-with-button');

    reviewDivs.forEach(function (div, index) {
      const cfg = SUMMARY_ROWS[index];
      if (!cfg) return;

      if (cfg.type === 'addon-split') {
        renderStep5Split(div, cfg);
        return;
      }

      const ul = div.querySelector('ul:not(.summary-ul-5a):not(.summary-ul-5b)') || div.querySelector('ul');

      let data = null;

      switch (cfg.type) {
        case 'variant':
          data = getVariantFromStep1();
          break;
        case 'addon':
          data = getSingleAddonStep(cfg.stepId);
          break;
        case 'addon-multi':
          data = getStep6Multi();
          break;
      }

      renderRow(ul, data);
    });
  }

  function bindEditButtons() {
    const container = document.querySelector('.edit-popup-btn-holder');
    if (!container) return;

    container.querySelectorAll('.crer-itnem-with-button').forEach(function (div, index) {
      const cfg = SUMMARY_ROWS[index];
      if (!cfg) return;

      const btn = div.querySelector('button');
      if (!btn || btn.dataset.summaryBound === '1') return;
      btn.dataset.summaryBound = '1';

      btn.addEventListener('click', function (e) {
        e.preventDefault();

        if (typeof window.goToStep === 'function') window.goToStep(cfg.goTo);

        if (cfg.type === 'addon-split' && typeof window.goToSubStep === 'function') {
          setTimeout(function () {
            window.goToSubStep('5a');
          }, 30);
        }
      });
    });
  }

  function hookUpdates() {
    document.addEventListener('change', function (e) {
      if (
        e.target.classList.contains('addon-checkbox') ||
        (e.target.matches('input[type="radio"]') &&
          (e.target.closest('#step1') || e.target.closest('.cd-custom-varient')))
      ) {
        updateReviewData();
      }
    });

    const prev = window.updateTotalUI;
    window.updateTotalUI = function () {
      if (typeof prev === 'function') prev();
      updateReviewData();
    };

    const prevGo = window.goToStep;
    window.goToStep = function (n) {
      const ok = typeof prevGo === 'function' ? prevGo(n) : true;
      if (ok !== false) setTimeout(updateReviewData, 80);
      return ok;
    };

    const prevSub = window.goToSubStep;
    window.goToSubStep = function (name) {
      const ok = typeof prevSub === 'function' ? prevSub(name) : true;
      if (ok !== false) setTimeout(updateReviewData, 80);
      return ok;
    };
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindEditButtons();
    hookUpdates();
    updateReviewData();
  });

  window.updateReviewData = updateReviewData;
})();
